
import Player from '@vimeo/player';
import { qs, qsa, cls } from './util/dom-utils';
import pubsub from './util/pubsub';

class VideoVimeo {
    constructor(el) {
        this.el = el;

        this.attachHandlers();
    }

	/**
	 * Opens a lightbox and creates an autoplaying vimeo player inside it
	 */
	handleCTAClick(id) {

        this.videoPlayerContainer = qs('.js-lightbox-videoplayer .video-player-container');

		const idVideo = id;

		this.player = new Player(this.videoPlayerContainer, {
			id: idVideo,
			width: 960
		});

		this.player.play();
    }
    

	/**
	 * Cleans up a video player
	 */
	handlePlayerLightboxClose($target) {
		if (this.player) {
			this.videoPlayerContainer.parentNode.removeChild(this.videoPlayerContainer);
			this.videoPlayerContainer = false;
            this.player = false;
            
            const node = document.createElement('div');
            node.className = 'video-player-container';

            qs('.lightbox-contents .lightbox-popup', $target).appendChild(node);

		}
    }
    
    attachHandlers() {

        this.el.addEventListener('click', (evt)=> {
            evt.preventDefault();
            const elClicked = evt.currentTarget;
            const idVideo = elClicked.getAttribute('data-video-id');
            this.handleCTAClick(idVideo);
        });

        pubsub.subscribe('LIGHTBOX_CLOSE', (_, $target) => {
			this.handlePlayerLightboxClose($target);
		});

    }

}

const _init = () => {

    let $cta = qsa('[data-lightbox="videoplayer"]');

    if ($cta.length) {
		$cta.forEach(el => {
			new VideoVimeo(el);
		});
    }
};

_init();